var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    width: 59.32,
    height: 31.596,
    viewBox: "275.492 35.829 59.32 31.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "noun-impression-3681447"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.428 49.442c4.496-4.309 15.673-13.613 28.724-13.613 13.05 0 24.228 9.304 28.723 13.613 1.25 1.186 1.25 3.122 0 4.37-4.495 4.31-15.673 13.613-28.723 13.613-13.05 0-24.228-9.304-28.724-13.612a3.018 3.018 0 0 1 0-4.371Zm28.724 13.487c6.244 0 11.302-5.057 11.302-11.302 0-6.244-5.058-11.302-11.302-11.302s-11.302 5.058-11.302 11.302c0 6.245 5.058 11.302 11.302 11.302Z",
    "data-name": "Path 155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.152 44.322c.687 0 1.373.124 1.998.312a3.815 3.815 0 0 0-.5 1.873c0 2.06 1.686 3.684 3.684 3.684.687 0 1.312-.187 1.874-.5.187.625.312 1.312.312 1.999 0 4.059-3.31 7.305-7.306 7.305s-7.368-3.309-7.368-7.368a7.275 7.275 0 0 1 7.306-7.305Z",
    "data-name": "Path 156"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.2e9c39c46ff4b4bc993a26b927dd2fea.svg";
export { ForwardRef as ReactComponent };